import { render, staticRenderFns } from "./TypePartImmobile.vue?vue&type=template&id=e4664894&"
import script from "./TypePartImmobile.vue?vue&type=script&lang=js&"
export * from "./TypePartImmobile.vue?vue&type=script&lang=js&"
import style0 from "./TypePartImmobile.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports